export default {
  vessels: [],
  pageable: null,
  countryCodes: []
};
